import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { _isAuthenticated, _isId, _isRole } from 'app/services/auth.service';
import { UserService } from 'app/services/models/user.service';
import { PageService } from 'app/services/models/page.service';


@Component({
  selector: '[core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrls: ['./core-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit {
  currentUser: any;

  @Input()
  layout = 'vertical';

  @Input()
  menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreMenuService: CoreMenuService,
    private userService: UserService,
    private pageService: PageService) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    // Set the menu either from the input or from the service
    //this.menu = this.menu || this._coreMenuService.getCurrentMenu();
    let data= null;
    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(async () => {

      if (_isAuthenticated) { // _isAuthenticated doğru şekilde tanımlandı mı?
        this.pageService.event$.subscribe(async result => {
          data = await this.pageService.getAllPage(_isId);
        })
        data = await this.pageService.getAllPage(_isId);
        // Gelen veriyi doğrudan menüye atıyoruz
        this.menu = data;

        menus = this.menu;

       //this._coreMenuService.register('main', this.menu);
        //this._coreMenuService.setCurrentMenu('main');
        // Change Detection'ı tetikleme
        this._changeDetectorRef.markForCheck();
      }


      // Sonucu kontrol edelim

      //   menuNames.forEach(element => {
      //     this.menu = data.filter(item => item.id === element && !item.hidden && !item.disabled);
      // });

      // this.menu = data;
      // console.log(this.menu);

      this._changeDetectorRef.markForCheck();
    });
  }
}

export let menus : any;
